<app-header></app-header>
<div class="page-content">
    <div class="orders-container" *ngIf="!loading()">
        <mat-accordion>
          <mat-expansion-panel *ngFor="let order of getMyOrders()">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="fas fa-receipt"></i> Order #{{ order.id }} - {{ order.status | titlecase }}
              </mat-panel-title>
            </mat-expansion-panel-header>
      
            <div class="order-details">
              <mat-card>
                <mat-card-content>
                  <p><strong>Client Order ID:</strong> {{ order.FK_ID_clientOrder }}</p>
                  <p><strong>Client Details ID:</strong> {{ order.FK_ID_clientDetails }}</p>
                  <p><strong>Status:</strong> <span [ngClass]="getStatusClass(order.status)">{{ order.status }}</span></p>
      
                  <h4><i class="fas fa-box"></i> Order Details</h4>
                  <ul *ngIf="order.orderDetails">
                    <li *ngFor="let item of getOrderField(order.orderDetails,'orderProducts')">
                      <i class="fas fa-check-circle"></i>
                      <strong>{{ item.title }}</strong> (x{{ item.quantity }})
                      <br>
                      <small>Product ID: {{ item.product_id }}</small> | 
                      <small>Variant ID: {{ item.variant_id }}</small>
                    </li>
                  </ul>
                  <div *ngIf="getOrderField(order.orderDetails,'paymentInfo')">
                    <h4><i class="fas fa-money-bill"></i> Payment Info</h4>
                    <ul>
                        <li>
                            <i class="fas fa-credit-card"></i>
                            <br>
                            <small>: {{ getOrderField(order.orderDetails,'paymentInfo')['payment_gateway_names'] }}</small> | 
                            <small>: {{ getOrderField(order.orderDetails,'paymentInfo')['financial_status'] }}</small>
                        </li>
                    </ul>
                  </div>
                  
      
                </mat-card-content>
              </mat-card>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
</div>
<mat-spinner *ngIf="loading()"></mat-spinner>
<app-footer></app-footer>